import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';
export function PainPoints() {
  return <section className="py-20 md:py-32 px-4 bg-dark-card/30" data-id="element-189">
      <div className="max-w-4xl mx-auto" data-id="element-190">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-191">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold/10 mb-6" data-id="element-192">
            <BookOpen className="w-8 h-8 text-gold" data-id="element-193" />
          </div>
          <h2 className="text-3xl md:text-5xl font-heading font-bold mb-8 text-white leading-tight" data-id="element-194">
            ¿Qué es Imperio Romano Legendario?
          </h2>
          <p className="text-xl text-text-secondary mb-6" data-id="element-195">
            Imperio Romano Legendario es una colección digital creada para
            descubrir el Imperio Romano de una forma clara, entretenida y
            visual.
          </p>
          <p className="text-xl text-text-secondary mb-6" data-id="element-196">
            A través de sus tomos y bonos explorarás la historia, los grandes
            emperadores, batallas legendarias, conspiraciones políticas,
            gladiadores, monumentos, mapas y el legado que esta extraordinaria
            civilización dejó al mundo.
          </p>
          <p className="text-xl text-text-secondary" data-id="element-197">
            Todo el contenido fue desarrollado para despertar la curiosidad,
            ampliar la cultura general y convertir el descubrimiento en una
            experiencia fascinante, sin necesidad de conocimientos previos.
          </p>
        </motion.div>
      </div>
    </section>;
}